import { Link } from 'react-router-dom';
import { useProducts } from '../api/hooks';
import { Card } from '../components/Card';

export default function Products() {
  const { data, isLoading, error } = useProducts();
  if (isLoading) return <p className="text-arcforge-500">載入中…</p>;
  if (error) return <p className="text-red-600">錯誤：{(error as Error).message}</p>;
  if (!data || data.length === 0)
    return (
      <p className="text-arcforge-500">
        尚無產品。試試對右下角的 chat 說「建一個貓咪咖啡廳預約系統」
      </p>
    );
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {data.map((p) => (
        <Link key={p.id} to={`/products/${p.id}`} className="block">
          <Card className="transition hover:shadow-md hover:border-arcforge-500">
            <h2 className="text-lg font-semibold text-arcforge-700">{p.name}</h2>
            <p className="mt-1 text-xs text-arcforge-500 font-mono">{p.id}</p>
            <p className="mt-2 text-xs text-arcforge-500">版本 v{p.current_version}</p>
            <a
              className="mt-3 block text-xs text-blue-600 hover:underline break-all"
              href={`https://${p.id}.raymond-ihh-tw.workers.dev`}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {p.id}.raymond-ihh-tw.workers.dev →
            </a>
          </Card>
        </Link>
      ))}
    </div>
  );
}
